// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1Huxv","additionalInfo":"AgreementModal_additionalInfo__3TJZq"};